<template>
    <div class="MentoringHeader container flex flex-col pt-16 md:pt-20 xl:pt-24">
        <div class="flex flex-col-reverse lg:flex-row">
            <div class="lg:max-w-xl">
                <h1 class="mb-4 text-2xl font-black text-black dark:text-white lg:text-5xl lg:leading-[65px]">
                    <slot name="title" />
                </h1>
                <CText class="mt-4 leading-[27.2px]" variant="muted">
                    <slot name="message1" />
                </CText>
                <div class="mt-4 flex flex-col gap-2 lg:mt-12 lg:flex-row">
                    <slot name="buttons" />
                </div>
            </div>
            <div>
                <slot name="image" />
            </div>
        </div>
        <div v-if="$slots.message2" class="flex flex-col py-10 sm:flex-row sm:pt-20">
            <img class="mb-1 h-[47px] w-[140px] sm:mb-0" src="@/assets/images/placeholder-profiles.png" />
            <CText class="mt-4 sm:my-auto sm:ml-4" variant="muted">
                <slot name="message2" />
            </CText>
        </div>
    </div>
</template>

<script setup lang="ts">
import CText from '@/components/ui/CText.vue'
</script>
